import API from '../api'
import convertPagableData from '../convertPagableData'
import getUrl from './paths'

export const getActiveDispatchPlans = () =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getActiveDispatchPlans)
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getDispatchPlansBySPO = (orderId, originalSupplierPoNumber) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getDispatchPlansBySPO, { orderId, originalSupplierPoNumber })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getAllDispatchPlans = (page = 0, size = 10, filters) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getAllDispatchPlans, { page, size, ...filters })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getAllDispatchPlanCards = (userId, page = 0, size = 10, dispatchPlanFilters = null) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getAllDispatchPlanCards, { userId, page, size, ...dispatchPlanFilters })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getDispatchPlanById = (dispatchPlanId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getByDispatchPlanId, { dispatchPlanId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getDispatchPlansByOrderIdApi = (orderId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getDispatchPlansByOrderId, { orderId })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getDetailedDispatchReport = (planDate = null) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getDetailedDispatchReport, { planDate }, {})
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getDispatchReportByPlatform = (planDate = null) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getDispatchReportByPlatform, { planDate }, {})
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})
